import Swal from "sweetalert2";

/* ============================================================================
   Alerts for the customer portal.

   The rule is about who has to ACT on the message.

   A success is an acknowledgement -- "sent", "saved" -- and the customer does
   nothing with it, so it dismisses itself and stays out of the way.

   An error is the opposite. Every one of these used to carry
   `showConfirmButton: false, timer: 1500` as well, so a message the customer had
   to read disappeared in a second and a half whether they had finished or not.
   The refusal shown to a customer whose policy has lapsed contains a phone
   number and an email address -- a second and a half is not long enough to read
   a phone number, let alone write it down -- and the same timer sat on the
   wrong-OTP and expired-OTP messages, which are equally things somebody needs to
   read before deciding what to do next.

   So errors have no timer and a Close button. The customer dismisses them.
   ============================================================================ */

const ANIMATION = {
  showClass: {
    popup: "animate__animated animate__fadeInUp animate__faster",
  },
  hideClass: {
    popup: "animate__animated animate__fadeOutDown animate__faster",
  },
};

/* Messages arrive from the API as plain text and some of them carry real line
   breaks -- the lapsed-policy refusal is three lines. SweetAlert's `title`
   collapses them, so errors render through `html` instead, with the text escaped
   first: it is server text, but escaping it costs nothing and means a stray
   angle bracket can never become markup. */
const toHtml = (message) => {
  const text = String(message == null ? "" : message);
  const escaped = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  return escaped.replace(/\r?\n/g, "<br />");
};

export const showMessage = (StatusCode, Message) => {
  if (StatusCode === 200) {
    // Unchanged: an acknowledgement nobody needs to act on.
    Swal.fire({
      icon: "success",
      title: Message,
      showConfirmButton: false,
      timer: 1000,
      ...ANIMATION,
    });
    return;
  }

  const isKnownError =
    StatusCode === 400 || StatusCode === 404 || StatusCode === 401;

  Swal.fire({
    icon: "error",
    html: toHtml(isKnownError ? Message : "An unexpected error occurred"),
    // No timer. The customer closes it when they have finished reading.
    showConfirmButton: true,
    confirmButtonText: "Close",
    // A stray click outside should not take away a phone number somebody is
    // halfway through copying.
    allowOutsideClick: false,
    ...ANIMATION,
  });
};
